import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import ImageIcon from '@material-ui/icons/Image';

const useStyles = makeStyles((theme) => ({
  backButton: {
    marginRight: theme.spacing(1),
  },
  img: {
    maxWidth: 700,
    overflow: 'hidden',
    display: 'block',
    width: '100%',
  },
  dotActive:{
    backgroundColor:'#009A3F',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  iconColorGreen: {
    color: '#009A3F',
  },
  textColorGreen: {
    color: '#009A3F',
    fontSize: '14px',
    fontWeight: '550'
  },
}));


export const DeliveryTest = (image) => {
  const tutorialSteps = image.images;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const [activeStep2, setActiveStep2] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleNext2 = () => {
    setActiveStep2((prevActiveStep2) => prevActiveStep2 + 1);
  };

  const handleBack2 = () => {
    setActiveStep2((prevActiveStep2) => prevActiveStep2 - 1);
  };

  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const DialogTitle = withStyles(useStyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography  {...other} >
        
      </MuiDialogTitle>
    );
  });

  return (
    <div className={classes.root}>
    <IconButton aria-label="Image" onClick={handleClickOpen}>
                  <ImageIcon className={classes.iconColorGreen}/>
                  <div  className={classes.textColorGreen}>Prueba de entrega</div>
                </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        scroll={'paper'}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        </DialogTitle>
        <DialogContent>
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        <div style={{marginTop:'3vh'}}>
      <img
        className={classes.img}
        src={tutorialSteps[activeStep2]}
        alt ="imagen POD"
      />
      <MobileStepper
      classes={{
        dotActive: classes.dotActive, // class name, e.g. `classes-nesting-root-x`
      }}
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep2}
        nextButton={
          <Button size="small" onClick={handleNext2} disabled={activeStep2 === maxSteps - 1}>
            {theme.direction === 'rtl' ? <KeyboardArrowLeft style={{color:'#009A3F'}} /> : <KeyboardArrowRight  style={{color:'#009A3F'}} />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack2} disabled={activeStep2 === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight style={{color:'#009A3F'}} /> : <KeyboardArrowLeft  style={{color:'#009A3F'}}/>}
          </Button>
        }
      />
    </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

